import { z } from 'zod';

import {
    StepBoxReveal,
    StepCardsReveal,
    StepGoldenTicketResult,
    StepGoldenTicketReveal,
    StepIdle,
    StepPackReveal,
} from '../constants/steps';
import { BoxSchema } from './Box';
import { GoldenTicketSchema } from './GoldenTicket';

export const BREAK_STEPS = [
    StepIdle, // Idle state, before box break starts
    StepBoxReveal, // Signal to start open box animation, revealing the pack
    StepPackReveal, // Signal to start open pack animation, revealing the cards
    StepCardsReveal, // Cards are revealed and ready to be shown
    StepGoldenTicketReveal, // Golden ticket is revealed
    StepGoldenTicketResult,
] as const;

export const BreakStepsSchema = z.enum(BREAK_STEPS);

export type BreakSteps = z.infer<typeof BreakStepsSchema>;

export const BreakSchema = z.object({
    id: z.string(),
    currentStep: BreakStepsSchema,
    currentCardIndex: z.number(),
    box: BoxSchema,
    goldenTicket: GoldenTicketSchema.nullish(),
});

export type Break = z.infer<typeof BreakSchema>;
